import React from 'react';

import classes from './Button.module.css';

const Button = (props) => (
	<button
		className={[classes.Button, classes[props.buttonType]].join(' ')}
		onClick={props.clicked}
		disabled={props.disabled}
		type={props.type ? 'button' : 'submit'}
	>
		{props.children}
	</button>
);

export default Button;
